import { formatDateTime } from "..";

const dateColumn = (accessor, Header) => ({
  id: accessor,
  Header,
  showTimeZone: true,
  accessor,
  Cell: (prop) => formatDateTime(prop.value, "DD MMM YYYY HH:mm"),
});

export default dateColumn;
